/* Title column gets the room (names wrap to 2 lines, never "One Piece (…" on
   one); figures column is value + bar + rank, which is fixed-width content. */
.rankings {
  --rank-cols: minmax(0, 1.15fr) minmax(0, 1fr);
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  border-left: 1px solid var(--border-subtle);
}

.rankHeader {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  padding: 0 var(--space-3);
  margin-bottom: var(--space-3);
}

.rankHeading {
  font-size: var(--text-lg);
  font-weight: var(--weight-bold);
  color: var(--text-secondary);
  margin: 0;
}

.rankScope {
  font-size: var(--text-xs);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.colHead {
  display: grid;
  grid-template-columns: var(--rank-cols);
  gap: var(--space-3);
  padding: 0 var(--space-3) var(--space-2);
  font-size: var(--text-xs);
  font-weight: var(--weight-semi);
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: var(--tracking-caps);
}

.colHead span:last-child {
  text-align: left;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 180px;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

/* Row — a 2-column grid, tall, divider between rows (grid feel of the OG). */
.row {
  display: grid;
  grid-template-columns: var(--rank-cols);
  align-items: center;
  gap: var(--space-3);
  padding: 7px var(--space-3) 9px;
  background: var(--bg-surface);
  cursor: pointer;
  position: relative;
  transition: background var(--duration-fast) var(--ease-default);
}

.row:hover {
  background: var(--bg-hover);
}

.row:hover .displayName {
  text-decoration: underline;
}

.rowActive {
  cursor: default;
  background: var(--bg-base);
  box-shadow: inset 3px 0 0 0 var(--accent-secondary);
}

.rowActive:hover {
  background: var(--bg-base);
}

.rowActive:hover .displayName {
  text-decoration: none;
}

/* Title cell: poster + 2-line name + entity icon */
.titleCell {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-width: 0;
  border-right: 1px solid var(--border-subtle);
  padding-right: var(--space-3);
}

.poster {
  width: 42px;
  height: 63px;
  border-radius: var(--radius-sm);
  object-fit: cover;
  background: var(--bg-elevated);
  border: 1px solid var(--border-subtle);
  flex-shrink: 0;
}

.displayName {
  flex: 1;
  min-width: 0;
  color: var(--text-secondary);
  font-size: var(--text-sm);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.displayNameActive {
  color: var(--text-primary);
  font-weight: var(--weight-semi);
}

.entityIcon {
  display: inline-flex;
  color: var(--text-muted);
  flex-shrink: 0;
}

/* Rank cell: revenue value + thin bottom bar on the left, big rank on the right */
.rankCell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.revBlock {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.revenueValue {
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
  font-size: var(--text-base);
  font-weight: var(--weight-semi);
}

.track {
  position: relative;
  height: 4px;
  width: 100%;
  border-radius: 999px;
  background: var(--bg-elevated);
  overflow: hidden;
}

.fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(to right, var(--accent-secondary), var(--accent-secondary-dark));
  min-width: 2px;
}

.rank {
  font-family: var(--font-display);
  font-weight: var(--weight-bold);
  font-size: 32px;
  line-height: 1;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}

.pound {
  color: var(--text-muted);
  font-size: 0.7em;
  margin-right: 1px;
}
